import { TbX } from 'react-icons/tb';

import { withStroke } from '../../utils/withStroke';

const XIcon = withStroke(TbX);

export { XIcon };
